import { createSelector } from "reselect";
import { removeExpiredSecrets } from "../../../models/pads";

export const selectkissSignSettingstate = createSelector(
    [(state) => state]
    , (state) => state.kissSignSettings
)

export const selectIsPadsLoading = createSelector([selectkissSignSettingstate], state => Boolean(state?.loading))
export const selectPads = createSelector(
    [selectkissSignSettingstate]
    , state => state?.pads?.length ? state.pads.map(p => removeExpiredSecrets(p)) : []
)
export const selectUnfinishedFilesFromPads = createSelector(
    [selectPads]
    , pads => pads.reduce((result, pad) => pad.unfinishedFiles ? result.concat(pad.unfinishedFiles) : result, [])
)